import { TAB_CATEGORY } from '@/constant/permission'
import { createI18nProperty } from '@/i18n'
import BlankLayout from '../layout/blankLayout.vue'
// import batchUploadRoute from './batchUpload/route'
import OpenQuestion from './invitation/openQuestion'
// import resumeEditor from './candidate/editor/index.vue'

// const basePath = `/v-admin/application/:jobId`

const routes = [
  // batchUploadRoute,
  // {
  //   name: 'candidateEditor',
  //   path: '/v-admin/application/job/:jobId/edit/:applicationId',
  //   component: resumeEditor,
  //   meta: {
  //     isEditMode: true,
  //     titleI18nKey: 'admin.application.candidate.title.editCandidate',
  //     rootLayout: {
  //       hiddenBackgroundImage: true,
  //       hiddenTabList: true,
  //       flexMode: true
  //     }
  //   }
  // },
  // {
  //   name: 'addCandidateResume',
  //   path: '/v-admin/application/job/:jobId/add',
  //   component: resumeEditor,
  //   meta: {
  //     isEditMode: false,
  //     titleI18nKey: 'admin.application.candidate.title.addCandidate',
  //     rootLayout: {
  //       hiddenBackgroundImage: true,
  //       hiddenTabList: true,
  //       flexMode: true
  //     }
  //   }
  // },
  {
    name: 'jobInvitations',
    path: '/v-admin/job/:jobId/application/invite/open-question',
    component: OpenQuestion,
    meta: {
      title: '',
      rootLayout: {
        hiddenBackgroundImage: true,
        hiddenTabList: true,
        flexMode: true
      }
    }
  }
]
const applicationRoute = {
  name: 'candidateLayout',
  path: '/candidates/:jobId/',
  component: BlankLayout,
  meta: {
    permission: TAB_CATEGORY.JOB,
    titleI18nKey: 'admin.candidate.title',
    tab: createI18nProperty({
      customClass: ['candidate'],
      customShowFunc: (hasPermission, currentRoute) => {
        if (!hasPermission) {
          return false
        }
        if (currentRoute.path === `/candidates/${currentRoute.params.candidateId}/`) {
          return true
        } else {
          let parent = currentRoute
          while ((parent = parent.meta._parent)) {
            if (parent === applicationRoute) {
              return true
            }
          }
          return false
        }
      }
    }, 'label', 'admin.candidate.tab')
  },
  children: routes
}
export default applicationRoute
